export const PLAYER_ANALYTICS_EVENT_NAME = {
  AD_COMPLETE: 'ad_complete',
  AD_DISCONTINUE: 'ad_discontinue',
  AD_POD_COMPLETE: 'ad_pod_complete',
  AD_START: 'ad_start',
  AD_STARTUP_PERFORMANCE: 'ad_startup_performance',
  CONTENT_START: 'content_start',
  CONTENT_STARTUP_PERFORMANCE: 'content_startup_performance',
  CUE_POINT_FILLED: 'cue_point_filled',
  PLAYER_PAGE_EXIT: 'player_page_exit',
  QUALITY_OF_SERVICES: 'quality_of_services',
  USER_FEEDBACK: 'user_feedback',
  FALLBACK: 'fallback',
} as const;
